import getOr from 'lodash/fp/getOr'
import get from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'

export const getMessages = get('messages')

export const getMessagesTranslator = state => key => pipe(getMessages, getOr(key, key))(state)
